import React, { Component } from "react";
import { useEffect, useState } from "react";

import { Bar } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import PropTypes from "prop-types";
import moment from "moment";

const BarChartDemandCusType = props => {

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (typeof number == "string") {
      if (number.includes("+")) {
        return (
          "+ " +
          parseFloat(number.replaceAll("+", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
      if (number.includes("-")) {
        return (
          "- " +
          parseFloat(number.replaceAll("-", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const [dataGraph, setDataGraph] = useState({
    labels: ["EGAT", "FUEL", "GSP", "INDNGD", "NGV", "SPP"],
    datasets: [
      {
        label: "Avg",
        backgroundColor: "#09D566", //437AD5
        borderColor: "#09D566",
        borderWidth: 1,
        hoverBackgroundColor: "#09D566", //437AD5
        hoverBorderColor: "#09D566",
        data: [1666, 180, 944, 736, 240, 1271],
        type: 'line',
        showLine: false,
        pointStyle: 'dash',
        pointRotation: 90,
        pointBorderWidth: 100,
        hoverBorderWidth: 100,
        datalabels: {
          color: '#74FFA6',
          font: {
            weight: 'bold',
            size: 14,
          }
        }
      },
      {
        label: "Cur",
        backgroundColor: "#FCEE9E", //2C3984
        borderColor: "#FFFFFF",
        borderWidth: 1,
        hoverBackgroundColor: "#FCEE9E", //3546A5
        hoverBorderColor: "#FFFFFF",
        data: [1333, 150, 956, 701, 87, 1406],
        type: 'bar',
        color: "#FFFFFF",
        datalabels: {
          color: '#FFFFFF', //3546A5
          font: {
            weight: 'bold',
            size: 14,
          }
        }
      },
    ],
  })

  const [option, setOption] = useState({
    maintainAspectRatio: false,
    plugins: {
      // Change options for ALL labels of THIS CHART
      datalabels: {
        align: 'top',
      }
    },
    layout: {
      padding: {
        right: 35
      }
    },
    scales: {
      dataset: [
        {
          barPercentage: 0.4,
        },
      ],
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          fontSize: 15,
          labelString: 'Customer Type',
          fontColor: "#FFFFFF",
          fontStyle: "bold",
        },
        gridLines: {
          display: true,
        },
        ticks: {
          fontColor: "#FFFFFF",
          fontStyle: "bold",
          fontSize: 14,
        },
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          fontSize: 15,
          labelString: 'MMscf',
          fontColor: "#FFFFFF",
          position: 'left',
          fontStyle: "bold",
        },
        gridLines: {
          display: true,
        },
        ticks: {
          fontColor: "#FFFFFF",
          fontStyle: "bold",
          fontSize: 14,
          // max:0,
          // min: 0,
          beginAtZero: true,
          callback: function (label, index, labels) {
            var val = Math.abs(label);
            // if (val >= 1000) {
            //   if (label < 0) {
            //     val = val * -1;
            //   }
            //   val = numberFormat(val / 1000, 1) + " K";
            // } else {
            if (label < 0) {
              val = val * -1;
            }
            val = numberFormat(val, 0);
            // }

            return val;
          },
        },
      }],
    },
    tooltips: {
      enabled: true,
      mode: 'nearest',
      intersect: false,
      titleFontSize: 20,
      bodyFontSize: 18,
      bodyFontStyle: "bold",
      callbacks: {
        label: function (tooltipItem, data) {
          // console.log(tooltipItem);
          // console.log(data);
          // var indice = tooltipItem.index;
          return " " + numberFormat(tooltipItem.yLabel, 0);
        }
      },
    },
    legend: {
      labels: {
        fontColor: "#FFFFFF",
        fontStyle: "bold",
        fontSize: 14,
      },
    },
  });

  useEffect(() => {
    renderGraph();
  }, [props.data, props.date]);

  const renderGraph = () => {

    // let data = props.data.sort(function (a, b) {
    //   return moment(a.REPORT_DATE).toDate() - moment(b.REPORT_DATE).toDate();
    // });

    let dataAvg = [...props.data.map(obj => obj.DEMAND_AVG_DATA)];

    let dataDemand = [...props.data.map(obj => obj.DEMAND_DATA)];

    let dataLabel = [...props.data.sort((a, b) =>
      a.DEMANDCOLUMN_ORDER > b.DEMANDCOLUMN_ORDER
        ? 1
        : b.DEMANDCOLUMN_ORDER > a.DEMANDCOLUMN_ORDER
        ? -1
        : 0
    ).map(obj => obj.DEMANDCOLUMN_NAME)];

    // let dateList = [
    //   ...data.map(obj =>
    //     moment(obj.REPORT_DATE).locale("en").format("D MMM YYYY")
    //   ),
    // ];


    setDataGraph({
      labels: dataLabel,
      datasets: [
        {
          label: "Avg",
          backgroundColor: "#09D566", //D5A043
          borderColor: "#09D566",
          borderWidth: 1,
          hoverBackgroundColor: "#09D566",
          hoverBorderColor: "#09D566",
          data: dataAvg,
          type: 'line',
          color: "#09D566",
          showLine: false,
          pointStyle: 'dash',
          pointRotation: 90,
          pointBorderWidth: 60,
          hoverBorderWidth: 70,
          datalabels: {
            color: '#74FFA6',
            anchor: "start",
            align: "right",
            offset: 21,
            rotation: -50,
            formatter: function (value, context) {
              if (value == 0) {
                return "";
              }
              return numberFormat(value, 0);
            },
            font: {
              weight: 'bold',
              size: 14,
            }
          }
        },

        {
          label: "Cur",
          backgroundColor: "#FCEE9E", //437AD5
          borderColor: "#FFFFFF",
          borderWidth: 1,
          hoverBorderWidth: 3,
          barPercentage: 0.5,
          hoverBackgroundColor: "#FCEE9E", //437AD5
          hoverBorderColor: "#FFFFFF",
          data: dataDemand,
          type: 'bar',
          color: "#FFFFFF",
          datalabels: {
            color: '#FFFFFF',
            anchor: "end",
            align: "top",
            offset: 0,
            formatter: function (value, context) {
              if (value == 0) {
                return "";
              }
              return numberFormat(value, 0);
            },
            font: {
              weight: 'bold',
              size: 14,
            }
          }
        },
      ],
    });

  };



  return (
    <React.Fragment>
      <Bar height={70} data={dataGraph} options={option} plugins={[ChartDataLabels]} />
    </React.Fragment>
  )
};

BarChartDemandCusType.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  date: PropTypes.any,
};
export default BarChartDemandCusType;

